import { BaseApiResponseModel } from "api/model/BaseApiResponseModel";
import { goodsPaths } from "api/apiPaths";
import client from "api/client";
import { GoodsRequestModel } from "./model/GoodsRequestModel";
import { GoodsResponseModel } from "./model/GoodsResponseModel";
import { GoodsCreateActionRequestModel } from "./model/actions/create/GoodsCreateActionRequestModel";
import { GoodsUpdateActionRequestModel } from "./model/actions/update/GoodsUpdateActionRequestModel";
import { GoodsDetailResponseModel } from "./model/detail/GoodsDetailResponseModel";

export interface IGoodsRepository {
  getList(
    params: GoodsRequestModel
  ): Promise<BaseApiResponseModel<GoodsResponseModel[]>>;
  getDetail(params: {
    code: string;
  }): Promise<BaseApiResponseModel<GoodsDetailResponseModel>>;
  createGoods(
    body: GoodsCreateActionRequestModel
  ): Promise<BaseApiResponseModel<GoodsDetailResponseModel>>;
  updateGoods(
    body: GoodsUpdateActionRequestModel
  ): Promise<BaseApiResponseModel<GoodsDetailResponseModel>>;
  deleteGoods(params: {
    code: string;
  }): Promise<BaseApiResponseModel<GoodsDetailResponseModel>>;
}

class GoodsImpl implements IGoodsRepository {
  async getList(
    params: GoodsRequestModel
  ): Promise<BaseApiResponseModel<GoodsResponseModel[]>> {
    return await client?.get(goodsPaths?.LIST, params);
  }

  async getDetail(params: {
    code: string;
  }): Promise<BaseApiResponseModel<GoodsDetailResponseModel>> {
    return await client?.get(goodsPaths?.DETAIL, params);
  }

  async createGoods(
    body: GoodsCreateActionRequestModel
  ): Promise<BaseApiResponseModel<GoodsDetailResponseModel>> {
    return await client?.post(goodsPaths?.CREATE, body);
  }

  async updateGoods(
    body: GoodsUpdateActionRequestModel
  ): Promise<BaseApiResponseModel<GoodsDetailResponseModel>> {
    return await client?.put(goodsPaths?.UPDATE, body);
  }

  async deleteGoods(params: {
    code: string;
  }): Promise<BaseApiResponseModel<GoodsDetailResponseModel>> {
    return await client?.delete(goodsPaths?.DELETE, params);
  }
}

export const defaultGoodsRepository = new GoodsImpl();
